import { Canvg } from 'https://cdn.skypack.dev/canvg@^4.0.0'

const cfg = JSON.parse(document.getElementById('pjs-custom-jersey').textContent)

/*
   The SVG the merchant stores in the setting carries ${data.customName} and
   ${data.customNumber}. It used to be interpolated by Liquid printing it inside a
   template literal, so the backtick resolved those against the local `data`. Coming
   from JSON it is a plain string, and the placeholders have to be filled here or the
   jersey shows them raw.
  */
function fillSvg (svg, data) {
  const escaped = svg.replace(/\\/g, '\\\\').replace(/`/g, '\\`')
  return new Function('data', 'return `' + escaped + '`')(data)
}

function SVGPropertiesSanitize (text) {
  return text.replaceAll('textpath', 'textPath').replaceAll('startoffset', 'startOffset')
}

document.addEventListener('DOMContentLoaded', function () {
  const canvasPreview = document.getElementById('canvas-custom-preview')
  const canvasName = document.createElement('canvas')
  const canvasNumber = document.createElement('canvas')
  const cName = document.getElementById('custom-name')
  const cNameCounter = document.getElementById('custom-name-counter')
  const cNumber = document.getElementById('custom-number')
  const mGIMGPreview = document.getElementById('modal-generate-img-preview')

  if (canvasPreview) {
    // canvas size for the name
    canvasName.width = 187
    canvasName.height = 45

    canvasNumber.width = 187
    canvasNumber.height = 45

    const canvas = {
      previewCanvas: canvasPreview,
      canvaName: canvasName,
      canvaNumber: canvasNumber
    }

    const formJersey = new CustomJersey(canvas, Canvg)
    formJersey.initializeContext('2d')

    // whether a mask exists to clip letters that overflow, at 900x900
    formJersey.initializeMask(cfg.maskUrl)

    const data = {
      image: cfg.image,
      customNumber: '00',
      customName: '',
      hasMask: cfg.hasMask,
      fontFamily: cfg.fontFamily,
      svgCode: {
        name: SVGPropertiesSanitize(cfg.defaultNameSvg),
        number: SVGPropertiesSanitize(cfg.defaultNumberSvg)
      },
      nameX: cfg.nameX,
      nameY: cfg.nameY,
      numberX: cfg.numberX,
      numberY: cfg.numberY
    }

    formJersey.sendToCanvas(data)

    // listeners
    cName.addEventListener('input', (e) => {
      const counter = 12 - e.target.value.length
      if (counter < 0) return false

      cNameCounter.innerText = counter

      const name = e.target.value != '' ? e.target.value : 'YOUR NAME'
      data.customName = name
      data.svgCode = {
        name: SVGPropertiesSanitize(fillSvg(cfg.nameSvg, data)),
        number: SVGPropertiesSanitize(fillSvg(cfg.numberSvg, data))
      }
      formJersey.sendToCanvas(data)
    })

    cNumber.addEventListener('input', (e) => {
      const number = e.target.value != '' ? e.target.value : '00'
      data.customNumber = number
      data.svgCode = {
        name: SVGPropertiesSanitize(fillSvg(cfg.nameSvg, data)),
        number: SVGPropertiesSanitize(fillSvg(cfg.numberSvg, data))
      }
      formJersey.sendToCanvas(data)
    })
  }
})
